import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Tabs, Spin } from 'antd';
import { Field } from 'redux-form';
import { TextField, TextAreaField, SelectField } from 'redux-form-antd';
import { Link } from 'react-router-dom';

import './index.css';
import AppTemplate from '../../templates/AppTemplate';
import InStoreTab from '../../../containers/InStoreTab';
import InHandTab from '../../../containers/InHandTab';
import TargetingTab from '../../../containers/targeting/TargetingTab';
import { StatusLabel } from '../../../services/helper';
import RangePicker from '../../molecules/RangePicker';
import CreativeTab from '../../../containers/CreativeTab';
import CpCheckinsForm from '../../../containers/CpCheckinsForm';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

const LineItem = ({
  campaign,
  approvalStatuses,
  ad,
  hasInstore,
  inHandCount,
  checkinCount,
  handleSubmit,
  submitting,
  loading,
}) => (
  <AppTemplate>
    <Spin spinning={loading}>
      <Row type="flex" justify="space-between">
        <Col span={20}>
          <h1>
            {ad.name}{' '}
            <small>
              for <Link to={`/campaigns/${campaign.id}`}>{campaign.name}</Link>
            </small>
          </h1>
        </Col>
        <Col span={4}>
          <StatusLabel record={ad} />
        </Col>
      </Row>
      <form onSubmit={handleSubmit} className="campaignForm">
        <Row>
          <Col span={12}>
            <Field {...formItemLayout} label="Name" name="name" component={TextField} />
            <RangePicker formItemLayout={formItemLayout} />
          </Col>
          <Col span={12}>
            <Field
              {...formItemLayout}
              label="Notes"
              name="description"
              rows={7}
              component={TextAreaField}
              extra={ad.action_id && `action_id in (${ad.action_id})`}
            />
          </Col>
          <Col span={12}>
            <Field
              {...formItemLayout}
              label="Approval"
              name="approval_status"
              component={SelectField}
              options={approvalStatuses.map(a => ({
                label: a.approval_status,
                value: a.approval_status,
              }))}
            />
          </Col>
        </Row>
        <Row>
          <Col offset={3}>
            <Link to={`/campaigns/${campaign.id}`}>Cancel</Link>
            <Button
              style={{ marginLeft: 10 }}
              type="primary"
              onClick={handleSubmit}
              loading={submitting}
            >
              Update
            </Button>
          </Col>
        </Row>
      </form>
      <Row style={{ marginTop: 20 }}>
        <Tabs type="card">
          <Tabs.TabPane forceRender tab="Targeting" key="1">
            <TargetingTab />
          </Tabs.TabPane>
          <Tabs.TabPane forceRender tab="Creative" key="2">
            <CreativeTab />
          </Tabs.TabPane>
          <Tabs.TabPane forceRender tab={!hasInstore ? 'inStore' : `inStore - 1`} key="3">
            <InStoreTab />
          </Tabs.TabPane>
          <Tabs.TabPane
            forceRender
            tab={!inHandCount ? 'inHand' : `inHand - ${inHandCount}`}
            key="4"
          >
            <InHandTab />
          </Tabs.TabPane>
          <Tabs.TabPane
            forceRender
            tab={!checkinCount ? 'CP Checkins' : `CP Checkins - ${checkinCount}`}
            key="5"
          >
            <CpCheckinsForm />
          </Tabs.TabPane>
        </Tabs>
      </Row>
    </Spin>
  </AppTemplate>
);

LineItem.defaultProps = {
  submitting: false,
};

LineItem.propTypes = {
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
};

export default LineItem;
